var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"body-2 grey--text text--darken-1"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }